import * as ActionIds from "../constants/codesets";

import type { CodeSetsActions } from "../actions/codesets";
import type { CodeSetsState } from "../models/codesets";

const EMPTY_CODESETS_STATE: CodeSetsState = {
  filter: {
    encounterType: null,
    facility: null,
    codeType: null,
    itemType: null,
    top: 20,
    search: "",
    skip: 0,
    order: [{ field: "Name", asc: true }],
  },
  busy: 0,
  codesets: null,
  codes: {},
  deletedCodeSets: [],
};

export function codesetsReducer(
  state: CodeSetsState = EMPTY_CODESETS_STATE,
  action: CodeSetsActions,
): CodeSetsState {
  switch (action.type) {
    case ActionIds.CODESETS_END_WAIT:
      if (state.busy <= 0) {
        console.error("CODESETS_END_WAIT happens more than CODESETS_BEGIN_WAIT");
        return state;
      }
      return {
        ...state,
        busy: state.busy - 1,
      };
    case ActionIds.CODESETS_BEGIN_WAIT:
      return {
        ...state,
        busy: state.busy + 1,
      };
    case ActionIds.CODESETS_UPDATE_CODESETS:
      return {
        ...state,
        filter: action.filter,
        codesets: action.codesets,
      };
    case ActionIds.CODESETS_UPDATE_CODES:
      return {
        ...state,
        codes: { ...state.codes, [action.id]: action.codes },
      };
    case ActionIds.CODESETS_MARK_DELETED_CODE:
      return {
        ...state,
        deletedCodeSets: [...state.deletedCodeSets, action.id],
      };

    default:
      return state;
  }
}
